// Frontend-only mock layer (no backend yet).
// Stores submissions in localStorage so the landing feels real and interactive.

export const MOCK_STORAGE_KEY = "tfs_payment_submissions_v1";

export const bankDetails = {
  bank: "Banco Produbanco",
  accountType: "Cuenta de Ahorros",
  accountNumber: "20006834181",
  holder: "Ana Paula Díaz",
  id: "1754204889",
  currency: "USD",
  reservationAmount: 250,
  fullInvestment: 250,
};

export const loadSubmissions = () => {
  try {
    const raw = localStorage.getItem(MOCK_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const saveSubmission = (submission) => {
  const current = loadSubmissions();
  const next = [submission, ...current].slice(0, 10);
  localStorage.setItem(MOCK_STORAGE_KEY, JSON.stringify(next));
  return next;
};

export const clearSubmissions = () => {
  localStorage.removeItem(MOCK_STORAGE_KEY);
};
